/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-02-06T13:44:03.623Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'Trans'

export default NICHE
